/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createParenthesisNode } from '../../factoriesNumber.js';
export var ParenthesisNodeDependencies = {
  NodeDependencies,
  createParenthesisNode
};